import { cx } from 'class-variance-authority';
import Head from 'next/head';
import React from 'react';

export const Page = ({
  id,
  dataE2E = '',
  className = '',
  description,
  noIndex,
  title,
  titleFull,
  children,
  ...props
}: PageProps) => {
  if (!title && !titleFull) {
    throw new Error('Page requires either a title or titleFull property');
  }

  const fullTitle = titleFull || `WellSaid – ${title}`;
  return (
    <div
      id={id}
      data-e2e={dataE2E}
      className={cx('page', className)}
      {...props}
    >
      <Head>
        <title>{fullTitle}</title>
        <meta property="og:title" content={fullTitle} />
        {description && (
          <meta property="og:description" content={description} />
        )}
        {description && <meta name="description" content={description} />}
        {noIndex && <meta name="robots" content="noindex" />}
      </Head>
      {children}
    </div>
  );
};

type Title =
  | { title: string; titleFull?: undefined }
  | { title?: undefined; titleFull: string };

export type PageProps = Title &
  Omit<React.HTMLProps<HTMLDivElement>, 'title'> & {
    id: string;
    dataE2E?: string;
    className?: string;
    description?: string;
    noIndex?: boolean;
  };

export default Page;
